const {last} = require("../../../../common/utils/collections");

export const getTargetElem = () => {
    // console.log(document.querySelectorAll("[xd-qa-type=\"modal\"], .modal-overlay-94d, .modal-overlay, .default-ui-4fz"))
    return (
        last(
            [...
                document.querySelectorAll(
                    "[xd-qa-type=\"modal\"], .modal-overlay-94d, .modal-overlay, .default-ui-4fz" +"," +
                    ".date-picker-8ub.expand"
                )]
                .filter((e) => !e.parentNode.classList.contains("tab-guard-0a127ee51b"))
        ) ??
        // document.querySelector("[xd-qa-type=\"modal\"]") ??
        // document.querySelector(".modal-overlay-94d") ??
        // document.querySelector(".modal-overlay") ??
        document.getElementById("root")
    );
};
